import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Box, Tooltip, Icon } from "@chakra-ui/react";
import { FiArrowUp } from "react-icons/fi";

const ScrollToTop = () => {
  const { pathname, search } = useLocation();
  const [isVisible, setIsVisible] = useState(false);

  // Automatically scroll to top on route change
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }, [pathname, search]);

  // Track scroll position for floating back-to-top button
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 320) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <Box
      position="fixed"
      bottom={{ base: "20px", md: "28px" }}
      right={{ base: "20px", md: "28px" }}
      zIndex="999"
      opacity={isVisible ? 1 : 0}
      visibility={isVisible ? "visible" : "hidden"}
      transform={isVisible ? "translateY(0) scale(1)" : "translateY(16px) scale(0.85)"}
      transition="all 0.3s cubic-bezier(0.16, 1, 0.3, 1)"
      pointerEvents={isVisible ? "auto" : "none"}
    >
      <Tooltip label="Back to top" placement="left" hasArrow bg="#0F172A" color="white" fontSize="12px" px="2" py="1" rounded="md">
        <Box
          as="button"
          onClick={scrollToTop}
          aria-label="Scroll to top"
          w={{ base: "42px", md: "46px" }}
          h={{ base: "42px", md: "46px" }}
          rounded="full"
          bg="#162237"
          color="white"
          display="flex"
          alignItems="center"
          justifyContent="center"
          boxShadow="0 4px 16px rgba(15, 23, 42, 0.25), 0 0 0 1px rgba(234, 179, 8, 0.25)"
          cursor="pointer"
          transition="all 0.25s cubic-bezier(0.16, 1, 0.3, 1)"
          _hover={{
            bg: "#0B1325",
            transform: "translateY(-3px)",
            boxShadow: "0 8px 24px rgba(15, 23, 42, 0.35), 0 0 0 2px #EAB308",
            color: "#EAB308",
          }}
          _active={{
            transform: "scale(0.95)",
          }}
        >
          <Icon as={FiArrowUp} boxSize={{ base: "20px", md: "22px" }} />
        </Box>
      </Tooltip>
    </Box>
  );
};

export default ScrollToTop;
